import styled from 'styled-components'
import { customTheme } from '../../../../styles/theme'
import CheckInput from '../../../../assets/images/check-input.png'

export const FormInput = styled.input`
  width: 100%;
  padding: 15px 12px;
  font-size: 14px;
  line-height: 1.428;
  color: ${customTheme.colors.black};
  background: ${customTheme.colors.gray['300']};
  border: 1px solid #828282;
  box-sizing: border-box;
  border-radius: 30px;
  &.password {
    padding-right: 36px;
  }
`

export const FormSelect = styled(FormInput).attrs({ as: 'select' })``

export const TextArea = styled(FormInput).attrs({ as: 'textarea' })`  
  background: ${({ value }) => value === '' ? '' : `url(${CheckInput}) no-repeat scroll 98% 10px`} ${customTheme.colors.gray['300']};
  border: 1px solid #828282;
  height: 97px;
  resize: none;
`
export const IconView = styled.div`  
  position: absolute;
  right: 10px;
  top: 41%;
`
